cb.define(['common/common_VM.Extend.js'], function () {

    var setCheckBoxEnum = function (data) {
        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }
    };

    var PM_pmc_offLinemutexstrategy_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {


            viewmodel.on('afterLoadData', function (data) {

                //是否选优惠券
                if (viewmodel.get('iCoupon').getValue() == true || viewmodel.get('iCoupon').getValue() == 'true') {
                    viewmodel.get('isAllCoupon').setVisible(true);
                    if (data.isAllCoupon == 0) {
                        viewmodel.get('lineCouponItem').setVisible(true);
                        viewmodel.get('lineCouponItem').setState('bIsNull', false);
                    } else {
                        viewmodel.get('lineCouponItem').setVisible(false);
                        viewmodel.get('lineCouponItem').setState('bIsNull', true);
                    }
                } else {
                    viewmodel.get('isAllCoupon').setVisible(false);
                    viewmodel.get('lineCouponItem').setVisible(false);
                }

                //促销选择
                if (viewmodel.get('iPromotionType').getValue() == 0) {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('linePromotionItem').setState('bIsNull', false);
                } else {
                    viewmodel.get('linePromotionItem').setVisible(false);
                    viewmodel.get('linePromotionActivity').setColumnState('name', 'bIsNull', false);
                    viewmodel.get('iSameTypeMutex').setVisible(false);
                }
            });

            const delPromotionActivity = () => {
                if (viewmodel.get('linePromotionActivity').getData() && viewmodel.get('linePromotionActivity').getData().length > 0) {
                    let pricenums = viewmodel.get('linePromotionActivity').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('linePromotionActivity').deleteRows(i);
                    }
                }
            }

            //选择促销
            viewmodel.get('iPromotionType').on('afterValueChange', function (data) {
                if (data.value.value == 0) {
                    viewmodel.get('iSameTypeMutex').setVisible(true);
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('linePromotionActivity').setColumnState('name', 'bIsNull', true);
                    delPromotionActivity();
                    viewmodel.get('linePromotionItem').setVisible(true);
                    viewmodel.get('linePromotionItem').setState('bIsNull', false);
                } else {
                    viewmodel.get('iSameTypeMutex').setVisible(false);
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: true
                    });
                    viewmodel.get('linePromotionActivity').setColumnState('name', 'bIsNull', false);
                    viewmodel.get('linePromotionItem').setVisible(false);
                    viewmodel.get('linePromotionItem').setState('bIsNull', true);
                    if (viewmodel.get('linePromotionItem').getValue() && viewmodel.get('linePromotionItem').getValue().length > 0) {
                        viewmodel.get('linePromotionItem').setValue([]);
                    }
                }

            })


            //优惠券
            viewmodel.get('iCoupon').on('afterValueChange', function (data) {
                if (data.value) {
                    viewmodel.get('isAllCoupon').setVisible(true);
                    if (viewmodel.get('isAllCoupon').getValue() == 0) {
                        viewmodel.get('lineCouponItem').setVisible(true);
                        viewmodel.get('lineCouponItem').setState('bIsNull', false);
                    } else {
                        viewmodel.get('lineCouponItem').setVisible(false);
                        viewmodel.get('lineCouponItem').setState('bIsNull', true);
                    }
                } else {
                    viewmodel.get('isAllCoupon').setVisible(false);
                    viewmodel.get('isAllCoupon').setValue(1);
                    viewmodel.get('lineCouponItem').setVisible(false);
                    viewmodel.get('lineCouponItem').setState('bIsNull', true);
                    if (viewmodel.get('lineCouponItem').getValue() && viewmodel.get('lineCouponItem').getValue().length > 0) {
                        viewmodel.get('lineCouponItem').setValue([]);
                    }
                }

            });

            // viewmodel.get("lineCouponItem").on('beforeBrowse', function () {
            //   let condition = {
            //     "isExtend": true,
            //     simpleVOs: []
            //   };
            //   condition.simpleVOs.push({
            //     field: 'type',
            //     op: 'neq',
            //     value1: 2
            //   });
            //   this.setFilter(condition);
            // });

            //优惠券Radio
            viewmodel.get('isAllCoupon').on('afterValueChange', function (data) {

                viewmodel.get('lineCouponItem').setVisible(false);
                if (data.value.value == 0) {
                    viewmodel.get('lineCouponItem').setVisible(true);
                    viewmodel.get('lineCouponItem').setState('bIsNull', false);
                } else {
                    viewmodel.get('lineCouponItem').setVisible(false);
                    viewmodel.get('lineCouponItem').setState('bIsNull', true);
                    if (viewmodel.get('lineCouponItem').getValue() && viewmodel.get('lineCouponItem').getValue().length > 0) {
                        viewmodel.get('lineCouponItem').setValue([]);
                    }
                }

            });

            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                let counts = viewmodel.get('linePromotionActivity').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("linePromotionActivity").deleteRows(rowIndexes);
            })

            //保存时，将true和false转化成0和1
            const convertDataType = (obj) => {

                if (obj.iIntegral == true) {
                    obj.iIntegral = 1;
                } else {
                    obj.iIntegral = 0;
                }

                if (obj.iMemberDiscountEnable == true) {
                    obj.iMemberDiscountEnable = 1;
                } else {
                    obj.iMemberDiscountEnable = 0;
                }

                if (obj.iSpotDiscountEnable == true) {
                    obj.iSpotDiscountEnable = 1;
                } else {
                    obj.iSpotDiscountEnable = 0;
                }

                if (obj.iOrderDiscountEnable == true) {
                    obj.iOrderDiscountEnable = 1;
                } else {
                    obj.iOrderDiscountEnable = 0;
                }

                if (obj.iSameTypeMutex == true) {
                    obj.iSameTypeMutex = 1;
                } else {
                    obj.iSameTypeMutex = 0;
                }

                if (obj.iCoupon == true) {
                    obj.iCoupon = 1;
                } else {
                    obj.iCoupon = 0;
                }

                if (obj.iPromotion == true) {
                    obj.iPromotion = 1;
                } else {
                    obj.iPromotion = 0;
                }
            }


            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);

                convertDataType(obj);
                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                //处理优惠券是否删除字段默认为0
                let lineCouponItem = obj.lineCouponItem;
                if (lineCouponItem != null && lineCouponItem.length > 0) {
                    for (let i = 0; i <= lineCouponItem.length; i++) {
                        if (lineCouponItem[i] != null) {
                            lineCouponItem[i].iDelete = 0;
                        }
                    }
                }

                if (viewmodel.get('iPromotionType').getValue() == 1) {
                    if (viewmodel.get('linePromotionActivity').getRows() == '') {
                        cb.utils.alert('促销活动不能为空', 'warning');
                        return false;
                    }
                }
                // if (obj.iCoupon == 0 && obj.iIntegral == 0 && obj.iMemberDiscountEnable == 0 && obj.iSpotDiscountEnable == 0 && obj.iOrderDiscountEnable == 0) {
                // 	cb.utils.alert('互斥项存在必须要多于两项以上(包含两项)', 'warning');
                // 	return false;
                // }
                data.data.data = JSON.stringify(obj);

            });
        }
    };
    try {
        module.exports = PM_pmc_offLinemutexstrategy_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_offLinemutexstrategy_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_offLinemutexstrategy_VM.Extend.js